import React from "react";
import { useSelector } from "react-redux";
import CmsPage from "../../../components/common/CmsPage";

export default function AboutUs() {
  const { user } = useSelector((state) => state.merchant);

  const role = user?.role || "user";

  const pageKey =
    role === "merchant"
      ? "about_us_merchant"
      : "about_us_user";

  return <CmsPage pageKey={pageKey} title="About Us" />;
}
